<template>
    <div class="row wrapperContent">
        <div class="col-md-12 col-sm-12" v-if="user.isEditor">
            <form novalidate>
                <div class="form-group">
                    <label>Titolo</label>
                    <div class="input-group">
                        <span class="input-group-addon input-group-addon-required">*</span>
                        <input type="text" class="form-control" v-model="model.titolo"
                            :class="{ 'parsley-error': errors.has('titolo') }">
                    </div>
                </div>
                <div class="form-group">
                    <label>Testo breve</label>
                    <div class="input-group">
                        <span class="input-group-addon input-group-addon-required">*</span>
                        <vue-tinymce id="sommario" v-model="model.sommario"
                            :options="options" :content="model.sommario"
                            @change="changedSommario"></vue-tinymce>
                    </div>
                </div>
                <div class="form-group">
                    <label>Testo</label>
                    <div class="input-group">
                        <span class="input-group-addon input-group-addon-required">*</span>
                            <vue-tinymce id="testo" v-model="model.testo"
                                :options="options" :content="model.testo"
                                @change="changedSommario"></vue-tinymce>
                    </div>
                </div>
                <div class="form-group row col-md-4 col-xs-12">
                    <label>Data di inizio pubblicazione</label>
                    <div class="input-group">
                        <div class="input-group-addon input-group-addon-required">*</div>
                        <el-date-picker v-model="dtaIni" type="datetime"
                            format="dd/MM/yyyy HH:mm:ss"
                            :class="{ 'parsley-error': errors.has('dtaIni') }"></el-date-picker>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="form-group row col-md-4 col-xs-12">
                    <label>Data di fine pubblicazione</label>
                    <el-date-picker v-model="dtaFin" type="datetime"
                        format="dd/MM/yyyy HH:mm:ss"
                        :class="{ 'parsley-error': errors.has('dtaFine') }"></el-date-picker>
                </div>
                <div class="clearfix"></div>
                <div class="linkSez">&nbsp;</div>
                <div class="row">
                    <div class="col-md-offset-3 col-md-6 col-xs-12 text-center">
                        <span class="text-danger">Campo obbligatorio (*)</span>
                    </div>
                    <div class="col-md-2 col-xs-12">
                        <button type="button" class="btn btn-primary btn-block" @click="save">
                            Salva
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-md-12 col-sm-12" v-else>
            <h1 class="underlined">{{model.titolo}}</h1>
            <div class="row anteprimaArt dettaglio">
                <div class="col-xs-12">
                    <p class="data">{{localDate}}</p>
                    <p v-html="model.testo"></p>
                </div>
            </div>
        </div>
        <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalTitle" ref="modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" v-if="modal.hasHeader">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title titolo" id="modalTitle">{{modal.title}}</h4>
                    </div>
                    <div class="modal-body" :style="modal.style">
                        <component :is="modal.component" :messages="modal.messages"></component>
                    </div>
                    <div class="modal-footer" v-if="modal.hasFooter">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Chiudi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.titolo {
    font-family: 'Libre Baskerville', serif;
    font-style: italic;
    font-size: 170%;
    font-weight: 400;
    margin-bottom: 0;
    text-transform: none;
}
.mce-tinymce {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
</style>

<script>
/*import tinymce from "tinymce/tinymce";
import "tinymce/themes/modern/theme";*/

import { DatePicker } from "element-ui";
import moment from "moment";
moment.locale("it");

import schema from "../../commons/validation/rules-validator.js";
import ErrorBag from "../../commons/validation/error-bag.js";
//import tinyMceDirective from "../../commons/cms/tiny-mce-directive.js";
import VueTinymce from "./vue-tinymce.vue";

const modal = {
    hasHeader: false,
    title: null,
    hasFooter: false,
    component: null
};

export default {
    name: "NotiziaView",

    components: {
        [DatePicker.name]: DatePicker,
        VueTinymce
    },

    /*directives: {
        "tinymce-editor": tinyMceDirective
    },*/

    data() {
        return {
            model: {
                sommario: "",
                testo: ""
            },

            descriptor: {
                type: "object",
                fields: {
                    titolo: { type: "string", required: true, whitespace: true, message: schema.formatMessage, msgProps: "TITOLO" },
                    sommario: { type: "string", required: true, whitespace: true, message: schema.formatMessage, msgProps: "TESTO BREVE" },
                    testo: { type: "string", required: true, whitespace: true, message: schema.formatMessage, msgProps: "TESTO"  },
                    dtaIni: { type: "date", format:"YYYY-MM-DD HH:mm:ss", required: true, message: schema.formatMessage, msgProps: "DATA INIZIO PUBBLICAZIONE"  },
                    dtaFine: [
                        { type: "date", format:"YYYY-MM-DD HH:mm:ss", message: schema.formatMessage, msgProps: "DATA FINE PUBBLICAZIONE" },
                        function(cb){
                            if(this.value === undefined || this.value === null){
                                return cb();
                            }
                            let dtaFin = moment(this.value, moment.ISO_8601);
                            if(!dtaFin.isValid()){
                                this.raise("il campo DATA FINE PUBBLICAZIONE non è valido");
                                return cb();
                            }
                            let dtaIni = moment(this.source.dtaIni, moment.ISO_8601);
                            if(dtaFin.isSameOrBefore(dtaIni)){
                                this.raise("il campo DATA FINE PUBBLICAZIONE deve essere posteriore al campo DATA INIZIO PUBBLICAZIONE");
                            }
                            cb();
                        }
                    ]
                }
            },

            modal: Object.assign({}, modal),

            errors: new ErrorBag(),

            options: {
                branding: false,
                content_css: ["https://fonts.googleapis.com/css?family=Open+Sans:400,300,300italic,400italic,600italic,600,700,700italic,800italic,800",
                    "/bundles/content-css", "/scripts/app/built/elenco-notizie/styles.css"],
                body_class: "cms-body",
                skin_url: "/scripts/tinymce/skins/lightgray"
            }
        };
    },
    computed: {
        user(){
            return this.$store.state.user || {};
        },
        not(){
            return this.$store.state.not;
        },
        dtaIni: {
            get(){
                let dta = moment.utc(this.model.dtaIni, moment.ISO_8601);
                if(dta.isValid()){
                    return dta.local().toDate();
                }
                return "";
            },
            set(value){
                if(value === undefined){
                    this.model.dtaIni = null;
                    return;
                }
                let dta = moment(value);
                if(dta.isValid()){
                    this.model.dtaIni = dta.utc().toISOString();
                } else {
                    this.model.dtaIni = null;
                }
            }
        },
        dtaFin: {
            get(){
                let dta = moment.utc(this.model.dtaFine, moment.ISO_8601);
                if(dta.isValid()){
                    return dta.local().toDate();
                }
                return "";
            },
            set(value){
                if(value === undefined){
                    this.model.dtaFine = null;
                    return;
                }
                let dta = moment(value);
                if(dta.isValid()){
                    this.model.dtaFine = dta.utc().toISOString();
                } else {
                    this.model.dtaFine = null;
                }
            }
        },
        localDate(){
            let m = moment.utc(this.model.dtaIni, moment.ISO_8601);
            if(m.isValid()){
                return m.local().format("DD MM YYYY");
            }
            return "";
        }
    },
    methods: {
        changedSommario(){
        },
        save(){
            let validator = new schema(this.descriptor);
            let model = JSON.parse(JSON.stringify(this.model), (key, value) => (value === null || value === undefined) ? undefined : value);
            model.servizio = window.NEWS_URLS.s;
            validator.validate(model).then(() => {
                this.$dataApi.save(model).then(() => {
                    this.modal = Object.assign(modal, {
                        hasHeader: false,
                        hasFooter: false,
                        title: null,
                        messages: ["Salvataggio effettuato"],
                        component: require("./dati-salvati.vue"),
                        style: {
                            padding: 0
                        }
                    });
                    $(this.$refs.modal).modal("show");
                    let vm = this;
                    setTimeout(function(){
                        $(vm.$refs.modal).modal("hide");
                        window.location.href = window.NEWS_URLS.parent;
                    }, 3000);
                }).catch(errors => {
                    if(!Array.isArray(errors)){
                        errors = [errors];
                    }
                    this.modal = Object.assign(modal, {
                        hasHeader: true,
                        hasFooter: true,
                        title: "errori",
                        messages: errors,
                        component: require("./errori.vue")
                    });
                    $(this.$refs.modal).modal("show");
                });
            }).catch(err => {
                let msgs = [ "Operazione non valida" ];
                if(err.errors){
                    msgs = err.errors.map(e => e.message);
                    this.errors = new ErrorBag(err.errors.map(e => {
                        return {
                            field: e.key,
                            message: e.message
                        };
                    }));
                }
                this.modal = Object.assign(modal, {
                    hasHeader: true,
                    hasFooter: true,
                    title: "errori",
                    messages: msgs,
                    component: require("./errori.vue")
                });
                $(this.$refs.modal).modal("show");
            });
        }
    },
    mounted(){
        this.$dataApi.getNotizia(this.not, window.NEWS_URLS.s)
            .then(resp => {
                this.model = resp;
            }).catch(errs => {
                if(errs.data && errs.data.Message){
                    errs = errs.data.Message;
                }
                if(!Array.isArray(errs)){
                    errs = [errs];
                }
                this.modal = Object.assign(modal, {
                    hasHeader: true,
                    hasFooter: true,
                    title: "errori",
                    messages: errs,
                    component: require("./errori.vue")
                });
                $(this.$refs.modal).modal("show");
            });
        let vm = this;
        $(this.$refs.modal).on("hidden.bs.modal", function(){
            vm.modal = Object.assign({}, modal);
        });
    }
};
</script>
